// Local YYYY-MM-DD (for native <input type="date"> min + comparisons)
export const todayISO = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

const START_HOUR = {
    "8 AM - 10 AM": 8, "10 AM - 12 PM": 10, "12 PM - 2 PM": 12,
    "2 PM - 4 PM": 14, "4 PM - 6 PM": 16, "6 PM - 8 PM": 18,
};

// A window is "past" (not bookable) when the selected date is today and its start hour has begun.
export const windowPast = (label, isToday) => {
    if (!isToday) return false;
    const h = START_HOUR[label];
    if (h == null) return false;
    return new Date().getHours() >= h;
};

export const firstFutureWindow = (windows, isToday) => {
    const avail = windows.filter((w) => !windowPast(w, isToday));
    return avail[0] || windows[windows.length - 1];
};
